import React from 'react';
import { Link } from 'react-router-dom';
import { LandingNav } from '../components/website/LandingNav';
import { LandingFooter } from '../components/website/LandingFooter';

export const NotFoundPage = () => {
    return (
        <div className="min-h-screen bg-white flex flex-col">
            <LandingNav />
            <div className="flex-1 pt-16">
                <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50/40 to-teal-50/30">
                    <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-100/60 rounded-full blur-3xl -translate-y-1/3 translate-x-1/3" />
                    <div className="relative z-10 text-center max-w-2xl mx-auto px-6">
                        <h1 className="text-8xl md:text-9xl font-bold text-slate-900 mb-4">404</h1>
                        <h2 className="text-3xl md:text-4xl font-semibold text-slate-800 mb-6 leading-tight">
                            The page you are looking for does not exist.
                        </h2>
                        <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                            Please check the URL and try again, or return to the homepage.
                        </p>
                        <Link
                            to="/"
                            className="inline-flex items-center justify-center bg-blue-700 hover:bg-blue-800 text-white px-8 py-3 rounded-lg text-sm font-medium transition-colors"
                        >
                            Back to Home
                        </Link>
                    </div>
                </section>
            </div>
            <LandingFooter />
        </div>
    );
};

export default NotFoundPage;